export default "__VITE_ASSET__DsClyUqH__"